import axios from "axios";
import _ from "lodash";
import dayjs from "dayjs";
import Resizer from "react-image-file-resizer";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { nanoid } from "nanoid";
import { useAppContext } from "../../hooks/useAppContext";
import CaltexCard from "../../components/UI/cards/CaltexCard";
import CaltexFormTitle from "../../components/UI/typographys/CaltexFormTitle";
import CaltexFormLabel from "../../components/UI/typographys/CaltexFormLabel";
import CaltexTextInput from "../../components/UI/inputs/CaltexTextInput";
import CaltexDatepicker from "../../components/UI/inputs/CatexDatepicker";
import CaltexNumberInput from "../../components/UI/inputs/CaltexNumberInput";
import CaltexUnitSelect from "../../components/UI/selects/CaltexUnitSelect";
import CaltexInnerCard from "../../components/UI/cards/CaltexInnerCard";
import CaltexRadio from "../../components/UI/radios/CaltexRadio";
import CaltexEmailAuto from "../../components/UI/inputs/CaltexEmailAuto";
import CaltexUpload from "../../components/UI/inputs/CaltexUpload";
import CaltexCheckbox from "../../components/UI/checkboxs/CaltexCheckbox";
import CaltexNumberInputOriginal from "../../components/UI/inputs/CaltexNumberInputOriginal";

import EngineOil from "../../pdfs/EngineOil";
import HydraulicOilPDF from "../../pdfs/HydraulicOil";
import CompressorOilPDF from "../../pdfs/CompressorOil";
import TurbineOilPDF from "../../pdfs/TurbineOil";
import IndustrialOilPDF from "../../pdfs/IndustrialOil";
import AutomotiveOilPDF from "../../pdfs/AutomotiveOil";
import TransmissionOilPDF from "../../pdfs/TransmissionOil";
import FinalDriveOilPDF from "../../pdfs/FinalDriveOil";
import CoolantPDF from "../../pdfs/Coolant";
import GreasePDF from "../../pdfs/Grease";

const LubewatchForm = () => {
    const { formName } = useParams();
    const { isSubmit, setIsSubmit, setPdfDatas } = useAppContext();
    const [dataFields, setDataFields] = useState([]);
    const [formFields, setFormFields] = useState([]);
    const [disabledSubmit, setDisabledSubmit] = useState(false);

    const resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                300,
                300,
                "JPEG",
                100,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64"
            );
        });

    const onSubmitForm = (e) => {
        e.preventDefault();

        setFormFields((prev) => {
            const previous = [...prev];
            const filteredItem = previous.filter((filter) => filter.required);
            filteredItem.map((item) => {
                if (Array.isArray(item.value)) {
                    return (item.isValid = Boolean(item.value.length));
                }

                return (item.isValid = Boolean(item.value));
            });

            return previous;
        });

        const falseInArray = formFields.some((item) => item.isValid === false);

        if (!falseInArray) {
            const filterHeaderOut = formFields.filter((item) => !item.isHeader);

            const prepareVariables = filterHeaderOut.map((item) => {
                if (item.type === "datepicker box") {
                    return { ...item, value: dayjs(item.value).format("DD/MM/YYYY") };
                } else {
                    return item;
                }
            });

            setPdfDatas(prepareVariables);
            setIsSubmit(true);
            setDisabledSubmit(true);
        }
    };

    const onChangeForm = (field, event, value) => {
        if (field.type === "text box") {
            setFormFields((prev) => {
                const previous = [...prev];
                const filteredItem = previous.find((filter) => filter.id === field.id);
                filteredItem.value = event.target.value;
                filteredItem.isValid = Boolean(event.target.value);
                return previous;
            });
        } else if (field.type === "number box") {
            setFormFields((prev) => {
                const previous = [...prev];
                const filteredItem = previous.find((filter) => filter.id === field.id);
                filteredItem.value = event.target.value;
                filteredItem.isValid = Boolean(event.target.value);
                return previous;
            });
        } else if (field.type === "email box") {
            setFormFields((prev) => {
                const previous = [...prev];
                const filteredItem = previous.find((filter) => filter.id === field.id);
                filteredItem.value = value;
                filteredItem.isValid = Boolean(value.length);
                return previous;
            });
        } else if (field.type === "datepicker box") {
            setFormFields((prev) => {
                const previous = [...prev];
                const filteredItem = previous.find((filter) => filter.id === field.id);
                filteredItem.value = event;
                filteredItem.isValid = Boolean(dayjs(event).format("DD/MM/YYYY"));
                return previous;
            });
        } else if (field.type === "lifetime box" || field.type === "temperature box") {
            setFormFields((prev) => {
                const previous = [...prev];
                const filteredItem = previous.find((filter) => filter.id === field.id);

                if (value && filteredItem.value) {
                    filteredItem.selectedUnit = value;
                } else {
                    filteredItem.value = event.target.value;
                }

                filteredItem.isValid = Boolean(filteredItem.value);
                return previous;
            });
        } else if (field.type === "radio box") {
            setFormFields((prev) => {
                const previous = [...prev];
                const filteredItem = previous.find((filter) => filter.id === field.id);
                filteredItem.value = event.target.value;
                filteredItem.isValid = Boolean(event.target.value);
                return previous;
            });
        } else if (field.type === "check box") {
            setFormFields((prev) => {
                const previous = [...prev];
                const filteredItem = previous.find((filter) => filter.id === field.id);

                if (event.target.checked) {
                    filteredItem.value = _.uniq([...filteredItem.value, event.target.name]);
                } else {
                    filteredItem.value = filteredItem.value.filter((item) => item !== event.target.name);
                }

                filteredItem.isValid = Boolean(filteredItem.value.length);
                return previous;
            });
        } else if (field.type === "img upload box") {
            setFormFields((prev) => {
                const previous = [...prev];
                const filteredItem = previous.find((filter) => filter.id === field.id);
                filteredItem.value = value;

                resizeFile(field.value)
                    .then((res) => {
                        filteredItem.imgBase64 = res;
                    })
                    .catch((e) => console.log(e));

                filteredItem.isValid = Boolean(value);
                return previous;
            });
        }
    };

    useEffect(() => {
        window.localStorage.clear();

        axios(`https://report.cxcbs.com/api/v1/ui_render/${formName}`, {
            headers: {
                Authorization: "abcdefghijklnmopqrswutxyz",
            },
        })
            .then((res) => {
                if (res.data.Code === "20000") {
                    setDataFields(res.data.Data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }, [formName]);

    useEffect(() => {
        if (dataFields.length > 0) {
            const formFields = dataFields.map((data) => {
                const formFields = [];

                if (data.topic) {
                    formFields.push({
                        topic: data.topic,
                        isHeader: true,
                    });
                }

                if (data.content.length > 0) {
                    // eslint-disable-next-line
                    data.content.map((content) => {
                        if (content.type === "lifetime box" || content.type === "temperature box") {
                            formFields.push({
                                id: nanoid(),
                                topic: content.topic,
                                name: content.name,
                                type: content.type,
                                error_message: content.err_msg,
                                required: content.required,
                                isValid: true,
                                unit: content.unit || [],
                                selectedUnit: content.unit[0],
                                value: "",
                            });
                        } else if (content.type === "radio box") {
                            formFields.push({
                                id: nanoid(),
                                topic: content.topic,
                                name: content.name,
                                type: content.type,
                                error_message: content.err_msg,
                                required: content.required,
                                isValid: true,
                                valueList: content.value || [],
                                value: content.value[0],
                            });
                        } else if (content.type === "check box") {
                            formFields.push({
                                id: nanoid(),
                                topic: content.topic,
                                name: content.name,
                                type: content.type,
                                error_message: content.err_msg,
                                required: content.required,
                                isValid: true,
                                valueList: content.value || [],
                                value: [],
                            });
                        } else {
                            formFields.push({
                                id: nanoid(),
                                topic: content.topic,
                                name: content.name,
                                type: content.type,
                                error_message: content.err_msg,
                                required: content.required,
                                isValid: true,
                                value: "",
                            });
                        }
                    });
                }

                return formFields;
            });

            const newFormFields = _.flatten(formFields);
            setFormFields(newFormFields);
        }
    }, [dataFields]);

    useEffect(() => {
        if (!isSubmit) {
            setDisabledSubmit(false);
        }
    }, [isSubmit]);

    return (
        <>
            <Helmet>
                <title>{_.capitalize(formName.replace("_", " "))} | Caltex Lubewatch</title>
            </Helmet>

            <Box
                sx={{
                    padding: "2rem 1rem",
                    display: "flex",
                    flexDirection: "column",
                    gap: "1.2rem",
                    maxWidth: "1024px",
                    margin: "0 auto",
                }}
            >
                <CaltexCard>
                    <Box sx={{ borderTop: "8px solid #004B61", padding: "1.5rem 1rem" }}>
                        <CaltexFormTitle>{_.capitalize(formName.replace("_", " "))}</CaltexFormTitle>
                        <Typography sx={{ color: "#333" }}>โปรดกรอกข้อมูลลงในฟอร์ม</Typography>
                    </Box>
                </CaltexCard>

                <form onSubmit={onSubmitForm}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "1.2rem" }}>
                        {formFields &&
                            // eslint-disable-next-line
                            formFields.map((field) => {
                                if (field.isHeader) {
                                    return (
                                        <CaltexCard key={nanoid()}>
                                            <Box
                                                sx={{
                                                    backgroundColor: "#004B61",
                                                    padding: "1.5rem 1rem",
                                                    borderRadius: "4px",
                                                }}
                                            >
                                                <Typography
                                                    sx={{ fontSize: "1rem", fontWeight: "500", color: "white" }}
                                                >
                                                    {field.topic}
                                                </Typography>
                                            </Box>
                                        </CaltexCard>
                                    );
                                } else {
                                    if (field.type === "text box") {
                                        return (
                                            <CaltexCard key={field.id}>
                                                <CaltexInnerCard>
                                                    <CaltexFormLabel>
                                                        {field.topic}
                                                        {field.required && (
                                                            <Typography component="span" sx={{ color: "red" }}>
                                                                *
                                                            </Typography>
                                                        )}
                                                    </CaltexFormLabel>
                                                    <CaltexTextInput
                                                        field={field}
                                                        name={field.name}
                                                        value={field.value}
                                                        onChange={(e) => onChangeForm(field, e)}
                                                    />
                                                    {!field.isValid && field.required && (
                                                        <Typography sx={{ fontSize: "0.875rem", color: "#ED1C24" }}>
                                                            {field.error_message}
                                                        </Typography>
                                                    )}
                                                </CaltexInnerCard>
                                            </CaltexCard>
                                        );
                                    } else if (field.type === "number box") {
                                        return (
                                            <CaltexCard key={field.id}>
                                                <CaltexInnerCard>
                                                    <CaltexFormLabel>
                                                        {field.topic}
                                                        {field.required && (
                                                            <Typography component="span" sx={{ color: "red" }}>
                                                                *
                                                            </Typography>
                                                        )}
                                                    </CaltexFormLabel>
                                                    <CaltexNumberInput
                                                        field={field}
                                                        name={field.name}
                                                        value={field.value}
                                                        onChange={(e) => onChangeForm(field, e)}
                                                    />
                                                    {!field.isValid && field.required && (
                                                        <Typography sx={{ fontSize: "0.875rem", color: "#ED1C24" }}>
                                                            {field.error_message}
                                                        </Typography>
                                                    )}
                                                </CaltexInnerCard>
                                            </CaltexCard>
                                        );
                                    } else if (field.type === "email box") {
                                        return (
                                            <CaltexCard key={field.id}>
                                                <CaltexInnerCard>
                                                    <CaltexFormLabel>
                                                        {field.topic}
                                                        {field.required && (
                                                            <Typography component="span" sx={{ color: "red" }}>
                                                                *
                                                            </Typography>
                                                        )}
                                                    </CaltexFormLabel>
                                                    <CaltexEmailAuto
                                                        field={field}
                                                        name={field.name}
                                                        value={field.value}
                                                        onChange={onChangeForm}
                                                    />
                                                    {!field.isValid && (
                                                        <Typography sx={{ fontSize: "0.875rem", color: "#ED1C24" }}>
                                                            {field.error_message}
                                                        </Typography>
                                                    )}
                                                </CaltexInnerCard>
                                            </CaltexCard>
                                        );
                                    } else if (field.type === "datepicker box") {
                                        return (
                                            <CaltexCard key={field.id}>
                                                <CaltexInnerCard>
                                                    <CaltexFormLabel>
                                                        {field.topic}
                                                        {field.required && (
                                                            <Typography component="span" sx={{ color: "red" }}>
                                                                *
                                                            </Typography>
                                                        )}
                                                    </CaltexFormLabel>
                                                    <CaltexDatepicker
                                                        field={field}
                                                        name={field.name}
                                                        value={field.value}
                                                        onChange={(e) => onChangeForm(field, e)}
                                                    />
                                                    {!field.isValid && field.required && (
                                                        <Typography sx={{ fontSize: "0.875rem", color: "#ED1C24" }}>
                                                            {field.error_message}
                                                        </Typography>
                                                    )}
                                                </CaltexInnerCard>
                                            </CaltexCard>
                                        );
                                    } else if (field.type === "lifetime box") {
                                        return (
                                            <CaltexCard key={field.id}>
                                                <CaltexInnerCard>
                                                    <CaltexFormLabel>{field.topic}</CaltexFormLabel>
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: "1.25rem" }}>
                                                        <CaltexNumberInputOriginal
                                                            style={{ minWidth: "150px" }}
                                                            placeholder={field.label}
                                                            field={field}
                                                            name={field.name}
                                                            value={field.value}
                                                            onChange={(e) => onChangeForm(field, e)}
                                                        />
                                                        <CaltexUnitSelect
                                                            units={field.unit}
                                                            value={field.selectedUnit}
                                                            onChange={(e) => onChangeForm(field, e, e.target.value)}
                                                            style={{
                                                                width: "100%",
                                                                maxWidth: "180px",
                                                                overflow: "hidden",
                                                            }}
                                                        />
                                                    </Box>
                                                    {!field.isValid && field.required && (
                                                        <Typography sx={{ fontSize: "0.875rem", color: "#ED1C24" }}>
                                                            {field.error_message}
                                                        </Typography>
                                                    )}
                                                </CaltexInnerCard>
                                            </CaltexCard>
                                        );
                                    } else if (field.type === "temperature box") {
                                        return (
                                            <CaltexCard key={field.id}>
                                                <CaltexInnerCard>
                                                    <CaltexFormLabel>{field.topic}</CaltexFormLabel>
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: "1.25rem" }}>
                                                        <CaltexNumberInput
                                                            style={{ minWidth: "150px" }}
                                                            placeholder={field.label}
                                                            field={field}
                                                            name={field.name}
                                                            value={field.value}
                                                            onChange={(e) => onChangeForm(field, e)}
                                                        />
                                                        <CaltexUnitSelect
                                                            units={field.unit}
                                                            value={field.selectedUnit}
                                                            onChange={(e) => onChangeForm(field, e, e.target.value)}
                                                            style={{
                                                                width: "100%",
                                                                maxWidth: "180px",
                                                                overflow: "hidden",
                                                            }}
                                                        />
                                                    </Box>
                                                    {!field.isValid && field.required && (
                                                        <Typography sx={{ fontSize: "0.875rem", color: "#ED1C24" }}>
                                                            {field.error_message}
                                                        </Typography>
                                                    )}
                                                </CaltexInnerCard>
                                            </CaltexCard>
                                        );
                                    } else if (field.type === "radio box") {
                                        return (
                                            <CaltexCard key={field.id}>
                                                <CaltexInnerCard>
                                                    <CaltexFormLabel>
                                                        {field.topic}
                                                        {field.required && (
                                                            <Typography component="span" sx={{ color: "red" }}>
                                                                *
                                                            </Typography>
                                                        )}
                                                    </CaltexFormLabel>
                                                    <CaltexRadio
                                                        field={field}
                                                        name={field.name}
                                                        value={field.value}
                                                        options={field.valueList}
                                                        onChange={(e) => onChangeForm(field, e)}
                                                    />
                                                    {!field.isValid && field.required && (
                                                        <Typography sx={{ fontSize: "0.875rem", color: "#ED1C24" }}>
                                                            {field.error_message}
                                                        </Typography>
                                                    )}
                                                </CaltexInnerCard>
                                            </CaltexCard>
                                        );
                                    } else if (field.type === "check box") {
                                        return (
                                            <CaltexCard key={field.id}>
                                                <CaltexInnerCard>
                                                    <CaltexFormLabel>
                                                        {field.topic}
                                                        {field.required && (
                                                            <Typography component="span" sx={{ color: "red" }}>
                                                                *
                                                            </Typography>
                                                        )}
                                                    </CaltexFormLabel>
                                                    <CaltexCheckbox
                                                        field={field}
                                                        name={field.name}
                                                        value={field.value}
                                                        options={field.valueList}
                                                        onChange={(e) => onChangeForm(field, e)}
                                                    />
                                                    {!field.isValid && field.required && (
                                                        <Typography sx={{ fontSize: "0.875rem", color: "#ED1C24" }}>
                                                            {field.error_message}
                                                        </Typography>
                                                    )}
                                                </CaltexInnerCard>
                                            </CaltexCard>
                                        );
                                    } else if (field.type === "img upload box") {
                                        return (
                                            <CaltexCard key={field.id}>
                                                <CaltexInnerCard>
                                                    <CaltexFormLabel>
                                                        {field.topic}
                                                        {field.required && (
                                                            <Typography component="span" sx={{ color: "red" }}>
                                                                *
                                                            </Typography>
                                                        )}
                                                    </CaltexFormLabel>
                                                    <CaltexUpload
                                                        field={field}
                                                        name={field.name}
                                                        value={field.value || []}
                                                        onChange={onChangeForm}
                                                    />
                                                    {!field.isValid && field.required && (
                                                        <Typography sx={{ fontSize: "0.875rem", color: "#ED1C24" }}>
                                                            {field.error_message}
                                                        </Typography>
                                                    )}
                                                </CaltexInnerCard>
                                            </CaltexCard>
                                        );
                                    }
                                }
                            })}

                        <Button
                            fullWidth
                            variant="contained"
                            type="submit"
                            sx={{
                                height: "50px",
                                backgroundColor: "#004B61",
                                "&:hover": {
                                    backgroundColor: "#004B61",
                                    opacity: "0.85",
                                },
                            }}
                            disabled={disabledSubmit}
                        >
                            Submit
                        </Button>
                    </Box>
                </form>

                {formName === "engine_oil" && <EngineOil />}
                {formName === "hydraulic_oil" && <HydraulicOilPDF />}
                {formName === "compressor_oil" && <CompressorOilPDF />}
                {formName === "turbine_oil" && <TurbineOilPDF />}
                {formName === "industrial_gear_oil" && <IndustrialOilPDF />}
                {formName === "automotive_gear_oil" && <AutomotiveOilPDF />}
                {formName === "transmission_oil" && <TransmissionOilPDF />}
                {formName === "final_drive_oil" && <FinalDriveOilPDF />}
                {formName === "coolant" && <CoolantPDF />}
                {formName === "grease" && <GreasePDF />}
            </Box>
        </>
    );
};

export default LubewatchForm;
